export default __webpack_public_path__ + "static/media/backgroundGrid.691643ac.svg";